import { AbiCoder } from 'ethers';
import useSWR from 'swr';
import { CONSTANTS } from '@/constants';
import { publicClient } from '@/utils/client';

async function fetchEggAddress({
  transactionHash,
  address,
}: {
  transactionHash: string;
  address: string;
}) {
  try {
    const SMASH_ADDRESS = CONSTANTS.SMASH_ADDRESS;
    if (!SMASH_ADDRESS || !transactionHash || !address) {
      return {
        eggAddress: '',
        isSmashFree: true,
      };
    }
    const transaction = await publicClient.waitForTransactionReceipt({
      hash: transactionHash as `0x${string}`,
    });

    const log = transaction.logs.find(
      (v) => v.address.toLowerCase() === SMASH_ADDRESS.toLowerCase(),
    );
    // the same smash address then: log of smash extra
    const numbers = transaction.logs.filter(
      (v) => v.address.toLowerCase() === SMASH_ADDRESS.toLowerCase(),
    );
    const defaultAbiCoder = AbiCoder.defaultAbiCoder();

    const filterOwner = numbers.find((item: any) => {
      const eoa = defaultAbiCoder.decode(['address'], item.topics[1])[0];

      return eoa.toLowerCase() === address.toLowerCase();
    });

    // Xử lý trường hợp 'log' hoặc 'filterOwner' có thể là 'undefined'.
    // Nếu không tìm thấy bất kỳ log SMASH nào, trả về sớm với giá trị mặc định.
    if (!log) {
      console.warn('Không tìm thấy log SMASH nào trong giao dịch.');
      return {
        eggAddress: '',
        isSmashFree: true,
      };
    }

    // Ưu tiên dữ liệu của filterOwner nếu nó tồn tại, nếu không thì sử dụng dữ liệu của log.
    // Chúng ta biết 'log' không phải là undefined ở đây, vì vậy 'log.data' an toàn để truy cập.
    // 'filterOwner' có thể là undefined, vì vậy sử dụng optional chaining 'filterOwner?.data'.
    const logData = filterOwner?.data ?? log.data;

    // Nếu vì lý do nào đó logData vẫn là undefined (ví dụ: log.data cũng là undefined, điều này khó xảy ra với một đối tượng log hợp lệ),
    // hãy xử lý một cách duyên dáng.
    if (!logData) {
      console.warn(
        'Không tìm thấy dữ liệu log hợp lệ để giải mã địa chỉ trứng.',
      );
      return {
        eggAddress: '',
        isSmashFree: true,
      };
    }

    return {
      eggAddress: defaultAbiCoder.decode(['address'], logData)[0],
      isSmashFree: numbers.length === 1,
    };
  } catch (error) {
    console.log('Error', error);
    return {
      eggAddress: '',
      isSmashFree: true,
    };
  }
}

export function useReward(address: string, txhash?: string) {
  const response = useSWR(
    txhash ? { key: 'reward', transactionHash: txhash, address } : null,
    fetchEggAddress,
    {
      dedupingInterval: 1000,
      refreshInterval: 0,
    },
  );
  return response;
}
